import { useEffect, useState } from 'react';

export default function useNotificationPermission() {
  const [permission, setPermission] = useState(Notification.permission);

  useEffect(() => {
    if (Notification.permission === 'default') {
      Notification.requestPermission().then(perm => setPermission(perm));
    }
  }, []);

  return permission;
}